// extracted by mini-css-extract-plugin
export default {"wrap":"DotCommon-wrap","statusColor":"DotCommon-statusColor"};